import { ProgramObjectivesBadge } from '@components/buzzkuri/shared/uiParts/badge/ProgramObjectives'
import { ProgramTagsBadge } from '@components/buzzkuri/shared/uiParts/badge/ProgramTags'
import { ProgramFeatureNumbers } from '@type/buzzkuri/program-detail'
import { ProgramLabel } from '@type/buzzkuri/programs'
import React from 'react'
import { ProgramFeatureContentBarGraph } from './BarGraph'
import { FeatureNumbersChart } from './FeatureNumbersChart'
import { ProgramFeatureContentLabelGroup } from './LabelGroup'

type Props = {
  feature: ProgramFeatureNumbers
  objectives: ProgramLabel[]
  tags: ProgramLabel[]
}

export const ProgramFeatureContent = ({
  feature,
  objectives,
  tags,
}: Props): JSX.Element => {
  const { entertainmentImpact, learningImpact } = feature
  return (
    <div className="flex flex-col lg:flex-row justify-center items-center lg:items-start p-[5.3vw] lg:px-[2.3vw] lg:pt-[2.3vw] lg:pb-0 w-[74.9vw] lg:w-[54.7vw] bg-gradient-to-b from-[#FFFDEF] to-[#FFFDEF] lg:border border-t border-[#F0B430]">
      <FeatureNumbersChart {...feature} />
      <div className="flex flex-col lg:mb-[2.3vw] lg:ml-[2.7vw]">
        <ProgramFeatureContentBarGraph
          {...{ entertainmentImpact, learningImpact }}
        />
        <div className="mt-[6vw] lg:mt-[1.6vw] lg:w-[25.3vw]">
          <ProgramFeatureContentLabelGroup heading="目的・ジャンル">
            <ProgramObjectivesBadge {...{ objectives }} />
          </ProgramFeatureContentLabelGroup>
        </div>
        <div className="mt-[3vw] lg:mt-[1.6vw]">
          <ProgramFeatureContentLabelGroup heading="タグ">
            <ProgramTagsBadge {...{ tags }} />
          </ProgramFeatureContentLabelGroup>
        </div>
      </div>
    </div>
  )
}
